
<div class="h-100">
<moduurnv2-email-login (modalValue)="showSubModal($event)"  *ngIf="pageToShow == 'LOGIN'"></moduurnv2-email-login>
<moduurnv2-email-sign-up (modalValue)="showSubModal($event)" *ngIf="pageToShow == 'REGISTER'" ></moduurnv2-email-sign-up>
<moduurnv2-email-forgot-password (modalValue)="showSubModal($event)" *ngIf="pageToShow == 'FORGOT-PASSWORD'"></moduurnv2-email-forgot-password>
</div>
